import request from '@/utils/request'

// --------- 担保 ---------
// 获取担保table数据
export const getTableData = params =>
  request.get(`/customer-api/company-assurances/page`, params)
// 新增客户担保
export const addCol = params =>
  request.post('/customer-api/company-assurances', params)
// 编辑客户担保
export const editCol = (id, params) =>
  request.put(`/customer-api/company-assurances/${id}`, params)
// 根据id获取当前担保信息
export const getColDetail = id =>
  request.get(`/customer-api/company-assurances/${id}`)
// 删除担保
export const deleteCol = params =>
  request.delete(`/customer-api/company-assurances/${params.id}`)
export const download = id =>
  request.get(
    `/customer-api/customer/attachment/download/${id}`,
    {},
    {
      responseType: 'blob',
    },
  )
